/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import {
  setToken,
  removeToken
} from '@/utils/auth'
import api from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false, // 是否正在加载中
    isLogin: false, // 是否已登录，默认未登录
    user: {} // 用户信息
  },
  mutations: {
    // 显示加载中状态
    SHOW_LOADING: (state, payload) => {
      state.loading = true
    },
    // 取消加载中状态
    HIDE_LOADING: (state, payload) => {
      state.loading = false
    },
    // 改变登录状态为已登录
    LOGIN_STATE_TRUE: (state, payload) => {
      state.isLogin = true
    },
    // 改变登录状态为未登录
    LOGIN_STATE_FALSE: (state, payload) => {
      state.isLogin = false
    },
    // 设置用户信息
    SET_USER_INFO: (state, payload) => {
      state.user = JSON.parse(JSON.stringify(payload))
    },
    // 清除用户信息
    CLEAR_USER_INFO: (state, payload) => {
      state.user = {}
    }
  },
  // 注册异步方法
  actions: {
    // // 用户名登录
    // login: ({
    //   commit,
    //   dispatch
    // }, userInfo) => {
    //   return new Promise((resolve, reject) => {
    //     api.login.r(userInfo).then(res => {
    //       // 更新vuex 中登录状态为已登录
    //       commit('LOGIN_STATE_TRUE')
    //       // 登录成功后，将token存储到浏览器存储中
    //       setToken('Bearer ' + res.data.tokenKey)
    //       // 登录成功后，获取用户信息
    //       dispatch('getUserInfo').then((res) => {}).catch(() => {})
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // // 获取用户信息
    // getUserInfo: ({
    //   commit,
    //   dispatch
    // }) => {
    //   return new Promise((resolve, reject) => {
    //     api.getUserInfo.r().then(res => {
    //       const data = res.data
    //       commit('SET_USER_INFO', data)
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // // 退出
    // logout: ({
    //   commit
    // }) => {
    //   return new Promise((resolve, reject) => {
    //     removeToken()
    //     resolve()
    //   })
    // }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js